import type { PropsWithChildren } from 'react';
import { useMantineTheme } from '@mantine/core';

import { useIsMobile } from '~/domains/common/hooks/mediaQueries';

import { Title } from '../../Title';

function DrawerTitle({
  children,
  isAddTopPaddingOnMobile,
}: PropsWithChildren<{ isAddTopPaddingOnMobile?: boolean }>) {
  const isMobile = useIsMobile();
  const theme = useMantineTheme();

  return (
    <Title
      ta="center"
      variant="headline-large"
      pt={isAddTopPaddingOnMobile && isMobile ? theme.other.spacing._16 : 0}
    >
      {children}
    </Title>
  );
}

export default DrawerTitle;
